// Hero KPI strip — 4 platform/tenant counts at the top of Home.
// All counts come from /api/home/widget/kpi-hero which is scope-aware.
import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Database, LayoutDashboard, Plug, Sparkles } from "lucide-react";

export default function KpiHeroWidget() {
    const [d, setD] = useState(null);
    useEffect(() => {
        api.get("/home/widget/kpi-hero").then((r) => setD(r.data)).catch(() => setD({}));
    }, []);
    const cells = [
        { label: "Datasets",    value: d?.datasets,       icon: Database,        accent: "text-sky-500" },
        { label: "Dashboards",  value: d?.dashboards,     icon: LayoutDashboard, accent: "text-emerald-500" },
        { label: "Connectors",  value: d?.connectors,     icon: Plug,            accent: "text-amber-500" },
        { label: "AI 30d ($)",  value: d?.ai_cost_30d,    icon: Sparkles,        accent: "text-primary",
          format: (v) => v == null ? "—" : `$${(+v).toFixed(2)}` },
    ];
    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="home-widget-kpi-hero">
            {cells.map(({ label, value, icon: Icon, accent, format }) => (
                <div key={label} className="border border-border rounded-sm bg-card p-4 flex items-start justify-between">
                    <div>
                        <div className="eyebrow text-[10px]">{label}</div>
                        <div className="kpi-number text-3xl mt-1.5">
                            {format ? format(value) : (value ?? "—")}
                        </div>
                    </div>
                    <Icon className={`h-5 w-5 ${accent} mt-0.5`} strokeWidth={1.5} />
                </div>
            ))}
        </div>
    );
}
